<template>
<div>安全设置</div>
</template>

<script>
export default {
  name: "security"
}
</script>

<style scoped>

</style>
